import { render, staticRenderFns } from "./authorized_access.vue?vue&type=template&id=45373db8&scoped=true"
import script from "./authorized_access.vue?vue&type=script&lang=js"
export * from "./authorized_access.vue?vue&type=script&lang=js"
import style0 from "./authorized_access.vue?vue&type=style&index=0&id=45373db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45373db8",
  null
  
)

export default component.exports